export { default } from './EnableErc20Content';
export * from './EnableErc20Content';
